import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    name = 'awsSupportStatuses',
    exports = storeModuleFactory({
        name,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        endpoint: endpoints.issueStatuses.endpoint
    });


module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/awsSupportStatuses.js